// Igual al contenedor 30x30 de BaseMapControl
const TOGGLE_BUTTON_SIZE = '30px'

/**
 * Estilos (sx) de los botones toggle de vista del mapa: Satélite, Solo puntos y
 * Códigos de árbol. Encendido: fondo azul marino de la marca con ícono blanco.
 *
 * El fondo activo va bajo '&&' (clase duplicada, especificidad 0,2,0) para ganar a
 * `.mapboxgl-ctrl-group button` (0,1,1) de mapbox-gl.css y MapControls.css, que fija
 * fondo blanco. Con ':hover' y ':active' (0,4,0) se conserva frente al hover de Mapbox
 * (0,3,1) y al gris de pulsación de MapControls.css (0,2,1).
 */
export const getMapToggleButtonStyles = (theme, active) => ({
  minWidth: TOGGLE_BUTTON_SIZE,
  width: TOGGLE_BUTTON_SIZE,
  height: TOGGLE_BUTTON_SIZE,
  padding: 0,
  margin: 0,
  color: active ? theme.palette.common.white : theme.palette.text.primary,
  ...(active && {
    '&&, &&:not(:disabled):hover, &&:not(:disabled):active': {
      bgcolor: theme.palette.primary.main,
    },
  }),
})
